export const PERMISSION_PREFIX = String(process.env.VUE_APP_AUTH_APP_ID || 'translation_manager').trim();
export const LOGIN_PAGE_URL = process.env.VUE_APP_LOGIN_PAGE_URL || '/';
export const AUTH_ENABLED = process.env.VUE_APP_AUTH_ENABLED !== 'false';

export function permissionsForDrive(prefix, drive) {
  const tool = prefix || PERMISSION_PREFIX;
  const page = String(drive || '').trim();
  return {
    FILES_BROWSE: `${tool}.${page}.browse.read`,
    FILES_CREATE: `${tool}.${page}.create.write`,
    FILES_UPDATE: `${tool}.${page}.update.write`,
    FILES_DELETE: `${tool}.${page}.delete.write`,
    TRANSLATION_AI: `${tool}.${page}.ai.write`
  };
}

export function hasPermission(permissions, permission) {
  const list = Array.isArray(permissions) ? permissions : [];
  if (list.includes('*')) return true;
  return Boolean(permission) && list.includes(permission);
}

export function canBrowseDrive(permissions, prefix, drive) {
  return hasPermission(permissions, permissionsForDrive(prefix, drive).FILES_BROWSE);
}

export function redirectToLogin() {
  if (!AUTH_ENABLED) return;
  if (!LOGIN_PAGE_URL || LOGIN_PAGE_URL === '/') return;
  window.location.href = LOGIN_PAGE_URL;
}
